function GiftCardSkeleton() {
  return (
    <div className="gift-card relative aspect-square w-full animate-pulse overflow-hidden rounded-2xl p-3">
      <div className="h-full w-full rounded-xl bg-[var(--color-card-elevated)]" />
      <div className="absolute inset-x-0 bottom-3 mx-auto h-5 w-16 rounded-full bg-[var(--color-text-muted)]/40" />
    </div>
  )
}

export default GiftCardSkeleton
